export enum ROLES {
  GUEST = 'Public',
  USER = 'Customer',
  RRPP = 'RRPP',
  TEAMLEADER = 'Team Leader',
  PROMOTER = 'Promoter',
  ADMIN = 'Admin',
  CONTROLLER = 'Controller'
}
